import {
  openStorageLimitDialog,
  StorageLimitError,
  STORAGE_FULL_STATUS,
} from "@/utils/storageLimitController";
import {
  BillingLimitError,
  BillingLimitParams,
  openBillingLimitModal,
  PAYMENT_REQUIRED_STATUS,
} from "@/utils/billingModalController";

/**
 * The chat stream goes out over fetch (AI SDK transport), so it never passes
 * through the axios interceptors in api-client.ts. This mirrors their 507 and
 * 402 handling: open the storage dialog or the billing limit modal and throw
 * an error the caller can recognise instead of treating it as a dropped
 * connection.
 */
export const limitAwareFetch: typeof fetch = async (input, init) => {
  const response = await fetch(input, init);
  if (response.status === STORAGE_FULL_STATUS) {
    openStorageLimitDialog();
    throw new StorageLimitError();
  }
  if (response.status === PAYMENT_REQUIRED_STATUS) {
    const body: { params?: BillingLimitParams } | null = await response
      .json()
      .catch(() => null);
    openBillingLimitModal(body?.params);
    throw new BillingLimitError();
  }
  return response;
};
